// --- API ---
// 通常配信とローカル開発は same-origin(`/api`) を使い、preview だけ別 origin を注入する。
// VITE_API_URL は preview 等でフロントエンドと API が別 origin の場合に設定する。
export const API_BASE_URL: string = import.meta.env.VITE_API_URL || '/api';
export const API_ORIGIN: string = import.meta.env.VITE_API_URL
  ? new URL(import.meta.env.VITE_API_URL).origin
  : location.origin;

// --- 環境識別 ---
// VITE_ENV_NAME: CI でビルド時に注入される環境名（dev / stg / prod）。
// ローカル開発時は未設定のため 'unknown' になる。
// 環境判定ロジックは system.ts に集約（isProd, isDebugEnabled 等）。
export const VITE_ENV_NAME: string = import.meta.env.VITE_ENV_NAME || 'unknown';

// --- 監視・分析 ---
// VITE_DATADOG_ENV: Datadog の environment タグ。preview では 'dev-preview' 等の固有値が入りうる。
export const VITE_DATADOG_ENV: string = import.meta.env.VITE_DATADOG_ENV || 'unknown';
export const VITE_RELEASE_VERSION: string = import.meta.env.VITE_RELEASE_VERSION || 'unknown';
export const VITE_UMAMI_DATA_WEBSITE_ID: string = import.meta.env.VITE_UMAMI_DATA_WEBSITE_ID || '';

// --- その他 ---
export const VITE_CONTACT_EMAIL: string = import.meta.env.VITE_CONTACT_EMAIL || '';
